var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xcard"},[_c('h3',{staticClass:"text-center text-primary"},[_vm._v("Registro de Persona")]),_c('p',{staticClass:"text-center"},[_vm._v("Complete el siguiente formulario con los datos de la persona para registralo en el sistema.")]),_c('a-reg-people')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }